import React, { useEffect, useState } from "react";
import CustomerHeader from "../Common/CustomerHeader";
import Stepper from "../Common/Stepper";
import { useNavigate } from "react-router-dom";
import {
  B2BOnBoardingSubmitApi,
  getEntityDetailsApi,
} from "../../services/redux/ApiActions";
import { useDispatch, useSelector } from "react-redux";
import LogoDiv from "../Common/LogoDiv";
import loading from "../../services/Loading.gif";
import logo from "../../img/BBPS_Horizontal.png";

export default function StepSix() {
  const customerData = useSelector(
    (state) => state?.customerData?.customerData,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState();
  const details = useSelector((state) => state?.details?.details);
  const [loadingVisible, setLoadingVisible] = useState(false); // State to manage loader visibility
  const [intervalId, setIntervalId] = useState(null); // State to store the interval ID
  const [errorMsg, setErrorMsg] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [showLogo, setShowLogo] = useState(false);

  const getDetails = async () => {
    const res = await dispatch(
      getEntityDetailsApi(customerData?.custId, customerData?.token_chr),
    );
    //console.log(res?.result);
    if (data?.result?.programId === 32 || data?.result?.programId === 33) {
      setShowLogo(true);
    } else {
      setShowLogo(false);
    }
    if (res?.result) {
      setData(res?.result);
      if (res?.result?.status !== "Wait") {
        setIsSuccess(true);
        setLoadingVisible(false);
        if (intervalId) {
          clearInterval(intervalId); // Clear the interval if status is not 'wait'
        }
      } else if (res?.result?.status === "Failure") {
        setErrorMsg(true);
        setLoadingVisible(false);
        if (intervalId) clearInterval(intervalId);
      } else {
        // Only 'Wait' should enter here
        setLoadingVisible(true);
      }
    }
  };

  useEffect(() => {
    getDetails(); // Call once on component mount
    if (!isSuccess) {
      const id = setInterval(() => {
        getDetails(); // Re-check every 10 seconds
      }, 10000);
      setIntervalId(id); // Store the interval ID
      return () => {
        clearInterval(id); // Clear the interval on component unmount
      };
    }
  }, [isSuccess]);

  const submit = async () => {
    if (data?.needAction === false) {
      navigate("/Customer/Step7");
    } else {
      const res = await dispatch(
        B2BOnBoardingSubmitApi(data, customerData?.token_chr),
      );
      if (res?.statusCode === 200) {
        navigate("/Customer/Step7");
      }
    }
  };

  return (
    <>
      {loadingVisible && (
        <div
          id="preloader"
          style={{
            width: "100%",
            height: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999999,
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div>
            <center>
              <img src={loading} alt="Loading..." />
            </center>
            <h4 className="mt-2 text-white">
              Waiting for Entity Details from NCPI...
            </h4>
          </div>
        </div>
      )}
      <body className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          B2B Onboarding
                        </h1>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {showLogo && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width="100px" height="100px" />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="mt-2 border-none border-collapse rounded-md">
                    <table className=" w-full">
                      <tbody>
                        {isSuccess && (
                          <>
                            <tr className="border-b-2">
                              {data?.existingB2BIds &&
                                data?.existingB2BIds.length > 0 &&
                                data.existingB2BIds[0] !== data.newB2BId && (
                                  <>
                                    <td
                                      className="w-full sm:w-1/4 p-2"
                                      align="left"
                                    >
                                      <label className="font-semibold">
                                        Default B2BIDs :{" "}
                                      </label>
                                    </td>
                                    <td
                                      className="p-2 text-sm text-gray-800"
                                      align="left"
                                    >
                                      {data.existingB2BIds.join(", ")}
                                    </td>
                                  </>
                                )}
                            </tr>
                            <tr className="border-b-2">
                              <td className="w-full sm:w-1/4 p-2" align="left">
                                <label className="font-semibold">
                                  New B2BID :{" "}
                                </label>
                              </td>
                              <td
                                className="p-2 text-sm text-gray-800"
                                align="left"
                              >
                                {data?.newB2BId}
                              </td>
                            </tr>
                          </>
                        )}
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">PAN : </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {data?.pan}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              Entity Name :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {data?.entityName}
                          </td>
                        </tr>
                        {/* <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">B2BIDS : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-gray-800" align="left">B2BIDS Response</td>
                                                </tr>
                                                <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">B2BID : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-gray-800" align="left">B2BID Response</td>
                                                </tr> */}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-2 border-none border-collapse rounded-md">
                    <div style={{ marginTop: "10px", marginBottom: "5px" }}>
                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: "400",
                          fontStyle: "italic",
                          color: errorMsg ? "red" : "green",
                        }}
                      >
                        {errorMsg
                          ? "Could not find the entity details,Please contact with V2P support team."
                          : ""}
                      </span>
                    </div>
                    <div className="col-span-12 md:col-span-7 lg:col-span-7">
                      <div className="relative text-center">
                        <button
                          disabled={isSuccess === true ? false : true}
                          style={{
                            opacity: isSuccess === true ? "1" : "0.5",
                          }}
                          className="vtpRm-action-button"
                          onClick={submit}
                        >
                          Submit
                        </button>
                        {/* <button onClick={handleSubmit} className="vtpRm-action-button">
                                                    {details?.result.gstin === '' || details?.result.gstin === undefined || details?.result.gstin === null ? 'Verify & Proceed' : 'Re-Verify & Proceed'}
                                                </button> */}
                        {details?.result.lastCompletedStep >= 6 ? (
                          <>
                            <span
                              className="skip-btn hover:cursor-pointer py-4 px-4"
                              onClick={() => navigate("/Customer/Step7")}
                            >
                              Skip this step
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </LogoDiv>
      </body>
    </>
  );
}
